import { AuthPageLayout } from "@/components/auth-page-layout";
import { LoginForm } from "@/components/login-form";
import { whoAmIOptions } from "@/client/@tanstack/react-query.gen";
import { retryFunc } from "@/api/retry";
import {
  createFileRoute,
  isRedirect,
  redirect,
} from "@tanstack/react-router";

function getErrorStatus(err: unknown): number | undefined {
  if (err && typeof err === "object" && "status" in err) {
    const s = (err as { status: unknown }).status;
    return typeof s === "number" ? s : undefined;
  }
  return undefined;
}

function toRoutePath(redirect: string | undefined, basepath: string) {
  if (!redirect) return "/";
  const b = basepath.replace(/\/$/, "");
  if (redirect === b || redirect === `${b}/`) return "/";
  if (redirect.startsWith(`${b}/`)) {
    const rest = redirect.slice(b.length);
    return rest.length > 0 ? rest : "/";
  }
  return redirect;
}

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect:
      typeof search.redirect === "string" ? search.redirect : undefined,
  }),
  beforeLoad: async ({ context, search }) => {
    const queryClient = context.queryClient;
    try {
      const user = await queryClient.ensureQueryData({
        ...whoAmIOptions(),
        retry: retryFunc,
      });
      if (user) {
        throw redirect({
          to: toRoutePath(search.redirect, "/shop"),
          replace: true,
        });
      }
    } catch (e) {
      if (isRedirect(e)) throw e;
      const status = getErrorStatus(e);
      if (status === 401 || status === 403) return;
      if (status == null) return;
      throw e;
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const { redirect: redirectAfterLogin } = Route.useSearch();

  return (
    <AuthPageLayout>
      <LoginForm redirectAfterLogin={redirectAfterLogin} />
    </AuthPageLayout>
  );
}
